export default __webpack_public_path__ + "static/media/InductorTableImg.b836afd9.png";